import {
  BuildTimeProperties,
} from '@o3r/core';
import {
  LocalizationConfiguration,
} from '@o3r/localization';
import {
  defaultLocalizationAppProp,
} from '@refx/shared-common';
import {
  ApplicationProperties,
} from './type';

/** Environment properties */
export const environment: Readonly<BuildTimeProperties & ApplicationProperties & Partial<LocalizationConfiguration>> = {
  production: true,
  DEBUG_MODE: false,
  APP_BASE_HREF: '.',
  APP_VERSION: '0.0.0',
  DEFAULT_LOC_BUNDLE_NAME: '',
  DEVTOOL_HISTORY_SIZE: undefined,
  ENABLE_GHOSTING: false,
  ENABLE_WEBSTORAGE: true,
  ENVIRONMENT: 'prod',
  LOCALIZATION_BUNDLES_OUTPUT: 'localizations/',
  bundlesOutputPath: 'localizations/', // TODO be removed when logic is done in the library to take LOCALIZATION_BUNDLES_OUTPUT by default
  USE_MOCKS: false,
  rtlLanguages: defaultLocalizationAppProp.rtlLanguages
};
